import { avatarColor, guestInitials, guestLabel } from '@/renderer/lib/utils';
import React from 'react';

interface UserInfoCardProps {
  firstName: string;
  lastName: string;
  email?: string;
}

export const UserInfoCard: React.FC<UserInfoCardProps> = ({
  firstName,
  lastName,
  email,
}) => {
  const initials = guestInitials({
    firstName,
    lastName,
  });

  const name = guestLabel({
    firstName,
    lastName,
  });
  const color = avatarColor(name);

  return (
    <div className="flex items-center gap-2 rounded-full bg-white shadow-lg border-gray-500/10 w-fit px-2 py-1">
      <div
        className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white ${color}`}
      >
        {initials}
      </div>
      <div>
        <p className="text-xs font-medium text-gray-900">{name}</p>
        {email && <p className="text-[10px] text-gray-400">{email}</p>}
      </div>
    </div>
  );
};
